import React from 'react';

import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from "@mui/material/Button";

import Styles from './oauth-register-pc-styles';
import EnvService from '../../../services/env.service';

export default function RegisterPc() {

    const { REACT_APP_AUTOATENDIMENTO_URL } = EnvService.getEnv();

    const classes = Styles()
    return (
        <Grid
            container
            justify="center"
            alignItems="center"
            className={classes.root}
        >
            <Box className={classes.container}>
                <Box className={classes.header}>
                    <img src="/images/marca-bb.png" className={classes.bbLogo} alt="BB" />
                    <img src="/images/logo-opb.png" className={classes.opbLogo} alt="BB" />
                </Box>
                <Typography variant="h1">
                    Banco do Brasil
                </Typography>
                <Box className={classes.content}>
                    <Typography variant="body1" className={classes.bold}>
                        Verificamos que este computador não está cadastrado
                        e necessita de liberação para utilizar esse canal.
                    </Typography>
                    <br />
                    <br />
                    <Typography variant="body1">
                        Acesse o autoatendimento e siga os passos para o novo cadastramento de computador
                    </Typography>
                </Box>
                <Button className={classes.button} onClick={() => window.location = REACT_APP_AUTOATENDIMENTO_URL}>
                    ir para autoatendimento
                </Button>
            </Box>
        </Grid>
    )
}